import { render, staticRenderFns } from "./CustomField.vue?vue&type=template&id=0df9986e&scoped=true"
import script from "./CustomField.vue?vue&type=script&lang=js"
export * from "./CustomField.vue?vue&type=script&lang=js"
import style0 from "./CustomField.vue?vue&type=style&index=0&id=0df9986e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df9986e",
  null
  
)

export default component.exports